import React, { useState } from 'react';
import { Modal, Checkbox, Button, Typography, message, Space } from 'antd';
import { api } from '../../http/API';

import './LegalAcceptModal.css';

const { Paragraph, Title } = Typography;

const OFFER_URL = 'https://agropogoda.com/static/files/public_offer.pdf';
const PRIVACY_URL = 'https://agropogoda.com/static/files/privacy.pdf';

interface Props {
    open: boolean;
    pending: string[];
    onAccepted: () => void;
}

const LegalAcceptModal: React.FC<Props> = ({ open, pending, onAccepted }) => {
    const [acceptOffer, setAcceptOffer] = useState(false);
    const [acceptPD, setAcceptPD] = useState(false);
    const [loading, setLoading] = useState(false);

    const needOffer = pending.includes('platform_offer');
    const needPD = pending.includes('pd_consent');

    const submit = async () => {
        if (needOffer && !acceptOffer) {
            message.error('Примите Публичную оферту платформы');
            return;
        }
        if (needPD && !acceptPD) {
            message.error('Дайте согласие на обработку персональных данных');
            return;
        }
        setLoading(true);
        try {
            await api.AcceptLegal(pending);
            message.success('Согласия приняты');
            onAccepted();
        } catch (e: any) {
            message.error(e?.response?.data?.message || 'Не удалось сохранить согласие');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            className="legal-accept-modal"
            open={open}
            closable={false}
            maskClosable={false}
            keyboard={false}
            title="Обновление документов"
            footer={[
                <Button key="ok" type="primary" size="large" loading={loading} onClick={submit}>
                    Принять и продолжить
                </Button>,
            ]}
            width={560}
        >
            <Paragraph>
                Для продолжения работы с платформой Агропогода примите, пожалуйста, актуальные
                документы:
            </Paragraph>

            <Space direction="vertical" size={16} style={{ width: '100%', marginTop: 8 }}>
                {needOffer && (
                    <Checkbox checked={acceptOffer} onChange={(e) => setAcceptOffer(e.target.checked)}>
                        <Title level={5} style={{ margin: 0 }}>
                            Публичная оферта платформы
                        </Title>
                        <Paragraph type="secondary" style={{ margin: 0 }}>
                            Ознакомиться:{' '}
                            <a href={OFFER_URL} target="_blank" rel="noreferrer">
                                public_offer.pdf
                            </a>
                        </Paragraph>
                    </Checkbox>
                )}
                {needPD && (
                    <Checkbox checked={acceptPD} onChange={(e) => setAcceptPD(e.target.checked)}>
                        <Title level={5} style={{ margin: 0 }}>
                            Согласие на обработку персональных данных
                        </Title>
                        <Paragraph type="secondary" style={{ margin: 0 }}>
                            Ознакомиться:{' '}
                            <a href={PRIVACY_URL} target="_blank" rel="noreferrer">
                                privacy.pdf
                            </a>
                        </Paragraph>
                    </Checkbox>
                )}
            </Space>
        </Modal>
    );
};

export default LegalAcceptModal;
